import React, { Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";

import { AppHandoff } from "./components/AppHandoff";
import { PublicHome } from "./components/PublicHome";
import { hasRestorableSession } from "./services/AuthService";

const AppShell = lazy(() =>
  import("./components/AppShell").then((module) => ({ default: module.AppShell })),
);

export function App() {
  const location = useLocation();
  const isPublicHome = location.pathname === "/";
  const isAuthCallback = location.pathname === "/stravaAuthComplete";
  const requiresAuthenticatedSession = !isPublicHome && !isAuthCallback;

  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-[var(--color-surface-canvas)] font-sans text-[var(--color-content-primary)] transition-[background-color,color] duration-[180ms] overscroll-none motion-reduce:transition-none">
      {isPublicHome || (requiresAuthenticatedSession && !hasRestorableSession()) ? (
        <PublicHome />
      ) : (
        <Suspense
          fallback={
            <div className="flex min-h-0 flex-1">
              <AppHandoff />
            </div>
          }
        >
          <AppShell hideMenu={isAuthCallback} />
        </Suspense>
      )}
    </div>
  );
}
